import * as types from './types';

export const setSchoolCandidatePartnerProfileHealth = (health) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_HEALTH,
  health
});

export const setSchoolCandidatePartnerProfileHousingPreferences = (housingPreferences) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_HOUSING_PREFERENCES,
  housingPreferences
});

export const setSchoolCandidatePartnerProfileLanguages = (languages) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_LANGUAGES,
  languages
});

export const setSchoolCandidatePartnerProfilePersonal = (personal) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_PERSONAL,
  personal
});

export const setSchoolCandidatePartnerProfileSecondarySchools = (secondarySchools) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_SECONDARY_SCHOOLS,
  secondarySchools
});

export const setSchoolCandidatePartnerProfileSportActivities = (sportActivities) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_SPORT_ACTIVITIES,
  sportActivities
});

export const setSchoolCandidatePartnerProfileBiographicalInformation = (biographicalInformation) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_BIOGRAPHICAL_INFORMATION,
  biographicalInformation
});

export const setSchoolCandidatePartnerProfileTeachingCredentials = (teachingCredentials) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_TEACHING_CREDENTIALS,
  teachingCredentials
});

export const setSchoolCandidatePartnerProfileTeachingExperience = (teachingExperience) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_TEACHING_EXPERIENCE,
  teachingExperience
});

export const setSchoolCandidatePartnerProfileUniversitiesColleges = (universitiesColleges) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_UNIVERSITIES_COLLEGES,
  universitiesColleges
});

export const setSchoolCandidatePartnerProfileContactInformation = (contactInformation) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_CONTACT_INFORMATION,
  contactInformation
});

export const setSchoolCandidatePartnerProfileDocuments = (documents) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_DOCUMENTS,
  documents
});




export const setSchoolCandidatePartnerProfileHealthLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_HEALTH_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileHousingPreferencesLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_HOUSING_PREFERENCES_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileLanguagesLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_LANGUAGES_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfilePersonalLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_PERSONAL_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileSecondarySchoolsLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_SECONDARY_SCHOOLS_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileSportActivitiesLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_SPORT_ACTIVITIES_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileBiographicalInformationLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_BIOGRAPHICAL_INFORMATION_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileTeachingCredentialsLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_TEACHING_CREDENTIALS_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileTeachingExperienceLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_TEACHING_EXPERIENCE_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileUniversitiesCollegesLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_UNIVERSITIES_COLLEGES_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileContactInformationLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_CONTACT_INFORMATION_LOADING,
  isLoading
});

export const setSchoolCandidatePartnerProfileDocumentsLoading = (isLoading) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_SET_DOCUMENTS_LOADING,
  isLoading
});



export const getSchoolCandidatePartnerProfileHealth = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_HEALTH,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileHousingPreferences = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_HOUSING_PREFERENCES,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileLanguages = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_LANGUAGES,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfilePersonal = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_PERSONAL,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileSecondarySchools = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_SECONDARY_SCHOOLS,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileDocuments = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_DOCUMENTS,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileSportActivities = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_SPORT_ACTIVITIES,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileBiographicalInformation = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_BIOGRAPHICAL_INFORMATION,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileTeachingCredentials = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_TEACHING_CREDENTIALS,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileTeachingExperience = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_TEACHING_EXPERIENCE,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileUniversitiesColleges = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_UNIVERSITIES_COLLEGES,
  schoolId, candidateId
});

export const getSchoolCandidatePartnerProfileContactInformation = (schoolId, candidateId) => ({
  type: types.SCHOOL_CANDIDATE_PARTNER_PROFILE_GET_CONTACT_INFORMATION,
  schoolId, candidateId
});


// WEBPACK FOOTER //
// ./src/actions/school-candidate/school-candidate-partner/index.js